import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { UtilsService } from "../../auth/service/utils.service";
import { locale as assetsIt } from "./i18n/assets.lang-it";
import assetsSettingsLinks from "./assets.settings-list";
import { RouterModule } from "@angular/router";
import assetsRoutes from "./assets.routes";
import assetsMenu from "./assets.menu";
import { ContentHeaderModule } from "../../layout/components/content-header/content-header.module";
import { TranslateModule } from "@ngx-translate/core";
import { NgxDatatableModule } from "@swimlane/ngx-datatable";
import { NgbDropdownModule, NgbPaginationModule, NgbTooltipModule } from "@ng-bootstrap/ng-bootstrap";
import { ExtendedModule } from "@angular/flex-layout";
import { CoreCommonModule } from "../../../@core/common.module";
import { NgSelectModule } from "@ng-select/ng-select";
import { AssetCategoriesComponent } from "./pages/categories/asset-categories.component";
import { AssetsDetailComponent } from "./pages/detail/assets-detail.component";
import { AssetsFormComponent } from "./pages/form/assets-form.component";
import { AssetImportComponent } from "./pages/import/asset-import.component";
import { AssetsListComponent } from "./pages/list/assets-list.component";
import { AssetsAssociateModalComponent } from "./components/associate-modal/assets-associate-modal.component";
import { AngularEditorModule } from "@kolkov/angular-editor";
import { AngularFileUploaderModule } from "angular-file-uploader";
import { StaffAssetsDocumentListComponent } from "./pages/staff-assets-document-list/staff-assets-document-list.component";
import { LayoutModule } from "../../layout/layout.module";
import { Ng2FlatpickrModule } from "ng2-flatpickr";
import { AuthenticationService } from "../../auth/service";

@NgModule({
  declarations: [AssetCategoriesComponent, AssetsDetailComponent, AssetsFormComponent, AssetImportComponent, AssetsListComponent, AssetsAssociateModalComponent, StaffAssetsDocumentListComponent],
  imports: [
    RouterModule.forChild(assetsRoutes),
    CommonModule,
    NgSelectModule,
    CoreCommonModule,
    ContentHeaderModule,
    TranslateModule,
    ExtendedModule,
    NgxDatatableModule,
    NgbTooltipModule,
    NgbPaginationModule,
    AngularEditorModule,
    NgbDropdownModule,
    AngularFileUploaderModule,
    LayoutModule,
    Ng2FlatpickrModule,
  ],
  exports: [
    AssetsAssociateModalComponent,
  ],
})
export class AssetsModule {
  constructor(private _utils: UtilsService, private _auth: AuthenticationService) {
    if(this._auth.currentUserSubject.value?.type === 'Dipendente') {
      this._utils.initModule("assets", assetsIt, assetsMenu, assetsSettingsLinks);
    }
  }
}
